exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__button___2YfNT{border-radius:35px;width:40px;height:40px;cursor:pointer;display:flex;justify-content:center;align-items:center;color:#fff}.index-module__button___2YfNT svg{font-size:25px}.index-module__sideMenu___2YnfR{z-index:50;background:#fff;top:0;left:0;position:fixed;height:100vh;width:275px;padding:2em;display:grid;justify-items:start;align-items:center;align-content:start;gap:2em}.index-module__sideMenu___2YnfR .index-module__area1___1s6iu,.index-module__sideMenu___2YnfR .index-module__area2___30JvM{grid-area:1/1}.index-module__sideMenu___2YnfR .index-module__area3___2yj7j{grid-area:2/1}.index-module__sideMenu___2YnfR .index-module__back___7BKM0{font-size:20px;justify-self:end;color:#46469a}.index-module__sideMenu___2YnfR ul li{margin-bottom:1em}.index-module__sideMenu___2YnfR ul li a{font-size:16px;color:#46469a;font-weight:500}", ""]);

// exports
exports.locals = {
	"button": "index-module__button___2YfNT",
	"sideMenu": "index-module__sideMenu___2YnfR",
	"area1": "index-module__area1___1s6iu",
	"area2": "index-module__area2___30JvM",
	"area3": "index-module__area3___2yj7j",
	"back": "index-module__back___7BKM0"
};